import { HttpErrorResponse } from '@angular/common/http';
import type {
  AdminSystemUser,
  UserTenantAssignment,
} from '../../../../domain/src/lib/admin-users/admin-user.model';

export const VAULT_USER_TENANTS_JWT_READONLY_HINT =
  'El rol operativo Vault (consulta, archivista, etc.) se asigna al crear o editar el usuario. Simappe solo usa DEVELOPER para el login técnico.';

/** @deprecated Usar `VAULT_USER_TENANTS_JWT_READONLY_HINT` */
export const VAULT_USER_TENANTS_API_UNAVAILABLE_MSG = VAULT_USER_TENANTS_JWT_READONLY_HINT;

export function mapAdminUserToTenantAssignments(user: AdminSystemUser): UserTenantAssignment[] {
  return (user.tenants ?? []).map((t) => ({
    id: t.id || `${user.id}-${t.tenant_id}`,
    user_id: user.id,
    tenant_id: t.tenant_id,
    role: t.role,
    tenant_name: t.tenant_name,
    tenant_slug: t.tenant_slug,
  }));
}

export function isUserTenantsEndpointMissing(err: unknown): boolean {
  return err instanceof HttpErrorResponse && (err.status === 404 || err.status === 405);
}

export function toUserTenantsApiError(err: unknown, fallback: string): string {
  if (err instanceof HttpErrorResponse) {
    const detail = err.error?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((d) => (typeof d === 'object' && d && 'msg' in d ? String((d as { msg: string }).msg) : String(d)))
        .join(' ');
    }
  }
  if (err instanceof Error && err.message.trim()) return err.message;
  return fallback;
}
